import { API_BASE, getToken } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Download, FileSpreadsheet, FileText } from "lucide-react";

/**
 * Renders an Export dropdown for a subscriber export base path.
 * basePath example: "/subscriber/export/animals" → fetches `.csv` or `.xlsx`.
 */
export default function ExportButton({ basePath, baseFilename, label, testId, size = "default" }) {
  const { t } = useT();

  const dl = async (ext) => {
    try {
      const res = await fetch(`${API_BASE}${basePath}.${ext}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      if (!res.ok) throw new Error("Failed");
      const blob = await res.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `${baseFilename}.${ext}`;
      a.click();
      toast.success(`${baseFilename}.${ext}`);
    } catch {
      toast.error("Export failed");
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid={testId}
          variant="outline"
          size={size === "sm" ? "sm" : "default"}
          className="rounded-full"
        >
          <Download className="w-4 h-4 mr-1.5" />
          {label || t("sub.export")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => dl("csv")} data-testid={`${testId}-csv`}>
          <FileText className="w-4 h-4 mr-2" /> {t("sub.csv")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => dl("xlsx")} data-testid={`${testId}-xlsx`}>
          <FileSpreadsheet className="w-4 h-4 mr-2" /> {t("sub.xlsx")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
